import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import RedBox from "./RedBox";
import CustomBrokrage from "./CustomBrokrage";
import ExpressFlyer from "./ExpressFlyer";
import InternationalFreight from "./InternationalFreight";
import StudentExpress from "./StudentExpress";
import USPasswordRenewal from "./USPasswordRenewal";
import Visatronix from './Visatronix';
import RegionalTrucking from './RegionalTrucking';


const International = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   

    return (
        <div>

            <div className="international-image">
                <img src='/international-banner/main-banner.jpg' alt='' className='w-[100%]' />

            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    Our International courier and logistics operation is your strong connection for moving anything 
                    to and from Pakistan, locally and globally. Our services include regular and discounted document services, 
                    <br/> PI-2 and PI-3, Student Express—which allows flat rate for educational organisations worldwide. 
                    We also cater to full range of international non-Doc services including PN, Export Express, Import Express 
                    and the Freight Plus, whether you need to ship something personally, as a B2B or a B2C customer.
                </p>
                <p>
                    With stations and hubs in the UK, UAE and Canada, our international operations always stay on top of the 
                    changing international trends so you can receive the best international courier and logistics services, 
                    round the clock, 365 days a year.
                </p>

                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="md:flex grid pb-[50px]">
                        <div className="md:flex-1 md:flex md:flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/international/redbox" className='font-bold'>RedBox</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/international/expressflyer" className='font-bold'>Express Flyer</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/international/uspasswordrenewal" className='font-bold'>US Passport Renewal</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/international/studentexpress" className='font-bold'>Student Express</Link></li>
                            </div>

                            <div className="flex items-center">
                                <li><Link to="/international/visatronix" className='font-bold'>Visatronix</Link></li>
                            </div>

                            <div className="flex items-center ">
                                <li><Link to="/international/internationalfreight" className='font-bold'>International Freight</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center">
                                <li><Link to="/international/custombrokrage" className='font-bold'>Customer Brokerage</Link></li>
                            </div>
                            <div className="flex items-center">
                                <li><Link to="/international/regional-trucking" className='font-bold'>Regional Trade / TIR</Link></li>
                            </div>
                        </div>
                    </div>
                </div>


            </div>

            <div className='mx-[2rem] md:mx-[2rem] lg:mx-[auto]'>
                
            <div id="redbox">
                <RedBox />
            </div>
            <div id="expressflyer">
                <ExpressFlyer />
            </div>
            <div id="uspasswordrenewal">
                <USPasswordRenewal />
            </div>
            <div id="studentexpress">
                <StudentExpress />
            </div>
            <div id="visatronix">
                <Visatronix />
            </div>
            <div id="internationalfreight">
                <InternationalFreight />
            </div>
            <div id="custombrokrage">
                <CustomBrokrage />
            </div>
            <div id="regional-trucking">
                <RegionalTrucking />
            </div>
            </div>
        </div>
    )
};
export default International;